import { useQuery } from "@tanstack/react-query";
import { peopleApi } from "../api/people";

const STATUS_COLORS: Record<string, string> = {
  active: "bg-emerald-100 text-emerald-800",
  occasional: "bg-amber-100 text-amber-800",
  inactive: "bg-slate-200 text-slate-700",
  never: "bg-rose-100 text-rose-800",
};

export default function People() {
  const { data, isLoading } = useQuery({ queryKey: ["people"], queryFn: () => peopleApi.list() });

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-slate-900">People</h2>
      <div className="overflow-hidden rounded-lg border border-slate-200 bg-white">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left text-xs uppercase text-slate-500">
            <tr>
              <th className="px-4 py-2">Email</th>
              <th className="px-4 py-2">Name</th>
              <th className="px-4 py-2">Department</th>
              <th className="px-4 py-2">Last Event</th>
              <th className="px-4 py-2 text-right">Chats</th>
              <th className="px-4 py-2">Last Chat</th>
              <th className="px-4 py-2">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {isLoading && (
              <tr>
                <td className="px-4 py-4 text-slate-500" colSpan={7}>
                  Loading…
                </td>
              </tr>
            )}
            {data?.map((p) => (
              <tr key={p.id}>
                <td className="px-4 py-2 font-mono text-xs text-slate-700">{p.email}</td>
                <td className="px-4 py-2">{p.name}</td>
                <td className="px-4 py-2">{p.department ?? "—"}</td>
                <td className="px-4 py-2 text-slate-500">
                  {p.last_event_at ? new Date(p.last_event_at).toLocaleString() : "—"}
                </td>
                <td className="px-4 py-2 text-right text-slate-700">
                  {p.conversation_count || "—"}
                </td>
                <td className="px-4 py-2 text-slate-500">
                  {p.last_conversation_at ? new Date(p.last_conversation_at).toLocaleString() : "—"}
                </td>
                <td className="px-4 py-2">
                  <span
                    className={`rounded px-2 py-0.5 text-xs ${
                      STATUS_COLORS[p.adoption_status] ?? ""
                    }`}
                  >
                    {p.adoption_status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
